import { render } from "./ProgramBatchDateTime.vue?vue&type=template&id=bc8e63da&scoped=true&ts=true"
import script from "./ProgramBatchDateTime.vue?vue&type=script&lang=ts"
export * from "./ProgramBatchDateTime.vue?vue&type=script&lang=ts"

import "./ProgramBatchDateTime.vue?vue&type=style&index=0&id=bc8e63da&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8e63da"]])

export default __exports__